import { Injectable } from "@angular/core";
import { CoreApiService } from "src/app/core/core-api.service";
import { endpoints } from "src/environments/endpoints";

interface ILogStoragePayload {
  message: string;
  level: string;
  applicationName: string;
}

@Injectable({
  providedIn: "root",
})
export class LogStorageService {
  constructor(private apiService: CoreApiService) {}

  logRequest(flow: string, form: string, endpoint: string, body: unknown) {
    this.sendLog("INFO", {
      flow,
      form,
      type: "body",
      endpoint,
      timestamp: new Date().toISOString(),
      data: this.sanitize(body),
    });
  }

  logResponse(flow: string, form: string, endpoint: string, response: unknown) {
    this.sendLog("INFO", {
      flow,
      form,
      type: "response",
      endpoint,
      timestamp: new Date().toISOString(),
      data: this.sanitize(response),
    });
  }

  private sendLog(level: string, payload: unknown) {
    try {
      const body: ILogStoragePayload = {
        message: this.safeStringify(payload),
        level,
        applicationName: "frontend-portal-pj-angular",
      };

      this.apiService.post(endpoints.armazenarLogs, body).subscribe({
        error: (error) => {
          console.error("Falha ao enviar logs.", error);
        },
      });
    } catch (error) {
      console.error("Falha ao enviar logs.", error);
    }
  }

  private sanitize(value: unknown): unknown {
    if (value === null || value === undefined) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map((item) => this.sanitize(item));
    }

    if (typeof value === "object") {
      const sanitized: Record<string, unknown> = {};

      for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
        if (this.isSenhaField(key)) {
          continue;
        }

        if (this.isEmailField(key) && typeof val === "string") {
          sanitized[key] = this.maskEmail(val);
        } else {
          sanitized[key] = this.sanitize(val);
        }
      }

      return sanitized;
    }

    return value;
  }

  private isSenhaField(key: string): boolean {
    const lower = key.toLowerCase();
    return lower === "senha" || lower === "password" || lower === "confirmasenha" || lower === "novasenha" || lower === "senhaantiga";
  }

  private isEmailField(key: string): boolean {
    return key.toLowerCase().includes("email");
  }

  private maskEmail(email: string): string {
    const atIndex = email.indexOf("@");
    if (atIndex <= 0) {
      return "***";
    }

    const local = email.substring(0, atIndex);
    const domain = email.substring(atIndex);
    const visible = local.substring(0, 1);
    const masked = visible + "*".repeat(Math.max(local.length - 1, 3));

    return masked + domain;
  }

  private safeStringify(value: unknown): string {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
}
